import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";
import config from "../config";


import logger from "../utils/logger";
const debug = config.runmode.debug;

const getStep = async (applicationId, accessToken) => {
  try {
    if (debug)
      logger.log(
        "Pobieranie danych bieżącego kroku procesu dla wniosku [" +
          applicationId +
          "]"
      );
    const response = await axios.post(
      ApiHost + `/process/get_current_step`,
      {
        applicationid: applicationId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data;
      if (debug) logger.log("getStep - content:", content);
      return content;
    }
  } catch (error) {
    logger.error(
      "Błąd podczas pobierania danych bieżącego kroku procesu dla wniosku: ",
      error
    );
  }
};

const commitStep = async (applicationId, userName, accessToken) => {
  try {
    if (debug)
      logger.log(
        "Potwierdzanie wykonania bieżącego kroku procesu dla wniosku [" +
          applicationId +
          "]"
      );
    const response = await axios.post(
      ApiHost + `/process/commit_step`,
      {
        applicationid: applicationId,
        username: userName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data;
      return content;
    }
  } catch (error) {
    logger.error(
      "Błąd podczas potwierdzania wykonania bieżącego kroku procesu dla wniosku: ",
      error
    );
  }
};

const addInputToStep = async (
  applicationId,
  inputValue,
  userName,
  accessToken
) => {
  try {
    if (debug)
      logger.log(
        "Dodawanie danych do bieżącego kroku procesu dla wniosku [" +
          applicationId +
          "]"
      );
    const response = await axios.post(
      ApiHost + `/process/add_input_to_step`,
      {
        applicationid: applicationId,
        inputvalue: inputValue,
        username: userName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data;
      return content;
    }
  } catch (error) {
    logger.error(
      "Błąd podczas dodawania danych do bieżącego kroku procesu dla wniosku: ",
      error
    );
  }
};

const start = async (applicationId, accessToken) => {
  try {
    if (debug)
      logger.log("Uruchamianie procesu dla wniosku [" + applicationId + "]");
    const response = await axios.post(
      ApiHost + `/process/start`,
      {
        applicationid: applicationId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data;
      return content;
    }
  } catch (error) {
    logger.error("Błąd podczas uruchamiania procesu dla wniosku: ", error);
  }
};

const getInstanceVariables = async (applicationId, accessToken) => {
  try {
    if (debug)
      logger.log(
        "Pobieranie zmiennych instancji dla wniosku [" + applicationId + "]"
      );
    const response = await axios.post(
      ApiHost + `/process/get_instance_variables`,
      {
        applicationid: applicationId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data;
      return content;
    }
  } catch (error) {
    logger.error(
      "Błąd podczas pobierania zmiennych instancji dla wniosku: ",
      error
    );
  }
};

export { addInputToStep, commitStep, getInstanceVariables, getStep, start };


